import { createApp, reactive } from 'vue'
import toastWidget from './toast.vue'
var params = reactive({
    show: false,
    message: '',
    type: null, // success fail
    theme: 1 // 0 ==> default  1 ==> center  2 ==> corner
})

const $uitoast = createApp(toastWidget, {params}).mount(document.createElement("div"))
var duration = 2000
if(params.theme == 2) duration = 5000
var uitoast = {
    success(message) {
        if(params.show) return
        params.show = true
        params.message = message
        params.type = 'success'
        document.body.appendChild($uitoast.$el)
        setTimeout(() => {
            params.show = false
        }, duration);
    },
    fail(message) {
        if(params.show) return
        params.show = true
        params.message = message
        params.type = 'fail'
        document.body.appendChild($uitoast.$el)
        setTimeout(() => {
            params.show = false
        }, duration);
    }
}
export default uitoast